import { useTranslation } from "react-i18next";
import "./flavour.css";
import CustomTabs from "../../../Components/CustomTabButton";
import customerImg from "../../../Images/customerTabImg.png";
import riderImg from "../../../Images/riderTabImg.png";

const TheArtflavour = () => {
  const { t } = useTranslation();

  const CustomerContent = () => (
    <div>
      <img src={customerImg} alt="Image" />{" "}
    </div>
  );

  // Rider Content
  const RiderContent = () => (
    <div>
      <img src={riderImg} alt="Image" />{" "}
    </div>
  );
  const tabs = [
    {
      id: "customer",
      label: t("foodarna.featuredWork.tabs.customer"),
      content: <CustomerContent />,
    },
    { id: "rider", label: t("foodarna.featuredWork.tabs.rider"), content: <RiderContent /> },
  ];

  const handleTabChange = (tabId) => {
    console.log("Active tab:", tabId);
  };

  return (
    <div className="foodrna-featurework">
      <h2 className="">{t("foodarna.featuredWork.title")}</h2>
      <div className="the-art-flavour">
        <CustomTabs tabs={tabs} defaultActiveTab="customer" onTabChange={handleTabChange} />
      </div>
    </div>
  );
};

export default TheArtflavour;
